import moduleConfig from './module-config';
import netsMfaForm from './nets-mfa-form';

export default angular
  .module('app.mfa-form', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsMfaForm', netsMfaForm);
